import React, {Component} from 'react';
import { connect } from 'react-redux';
// Components
import ReplaySection from 'components/presentational/ReplaySection';
import Footer from 'components/presentational/Footer';
import QuestionsSVG from 'components/svg/QuestionsSVG.js';
import GTMPush from 'components/GTMPush'

// Functions
import {
    setSectionAsAnimated,
    setAudioToPlay,
    incrementAudioPlayCount,
    stopAudio
} from 'redux/actions';

import animation from './animation.js'
// Files
import './question.scss';

const mapStateToProps = state => {
    return {
        volumeIsOn: state.volumeIsOn,
        animatedSections: state.animatedSections,
        userInteracted: state.userInteracted,
        nonTca: process.env.REACT_APP_NON_TCA
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSectionAsAnimated: (val) => dispatch(setSectionAsAnimated(val)),
        setAudioToPlay: (audioKey) => dispatch(setAudioToPlay(audioKey)),
        incrementAudioPlayCount: () => dispatch(incrementAudioPlayCount()),
        stopAudio: () => dispatch(stopAudio())
    };
};

class ConnectedQuestions extends Component {
    constructor() {
        super();
        this.image = React.createRef();
        this.audio = React.createRef();

        // Bindings
        this.handleReplayClick = this.handleReplayClick.bind(this);
        this.playAudio = this.playAudio.bind(this);
    }

    componentDidMount() {
        if (this.props.userInteracted && !this.props.animatedSections.some(el => el === this.props.id)) {
            this.animateSection();
        } else {
            // This will fire if we went back a page. If so, stop the current audio from playing.
            this.props.stopAudio();
        }
    }

    componentWillUpdate(nextProps) {
        if (nextProps.userInteracted && !this.props.userInteracted) {
            this.animateSection();
        }
    }

    componentWillUnmount() {
        this.props.setSectionAsAnimated(this.props.id);
    }

    playAudio() {
        this.props.setAudioToPlay('Questions');
        this.props.incrementAudioPlayCount();
    }

    animateSection() {
        animation(this.playAudio);
    }

    handleReplayClick() {
        this.animateSection();
    }
  
    render() {
        return (
            <div className="questions text-center" >
            
                <GTMPush 
                  event="pageLoad" 
                  virtualPath={this.props.location.pathname} 
                  pageNo="06" 
                  pageName={this.props.pageName} 
                  quizAnswer="undefined" />
                  
                <div className="container">
                    <h1 className="questions__heading heading-1">We’re here for you</h1>

                    <div className="questions__content">
                        <p>If you have any questions or concerns, call us at <strong>1&#8209;800&#8209;MET&#8209;6420 (638&#8209;6420), prompt 2.</strong> We’re here to help you during this difficult time. </p>
                    </div>


                    <QuestionsSVG ref={this.image} className="questions__image"/>

                    <ReplaySection handleClick={this.handleReplayClick}/>
                    
                    { !this.props.nonTca ? (
                        <div className="legal-info"><div>©2023 MetLife Services and Solutions, LLC</div></div>
                        ) : ( 
                        <div className="legal-info"><div>©2023 MetLife Services and Solutions, LLC</div></div>
                    )}                    
                </div>

                <Footer pageIndex={6}/>
            </div>
        )
    }
}

const Questions = connect(mapStateToProps, mapDispatchToProps)(ConnectedQuestions);

export default Questions
